(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .factory('HandbookSearch', HandbookSearch);

    HandbookSearch.$inject = ['$resource'];

    function HandbookSearch($resource) {
        var resourceUrl =  'api/_search/handbooks/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
